// 自社開発プロダクト実績データ
// ノウハウ流出を避けて、概要のみ簡潔に記載

export interface Product {
  id: string;
  name: string;
  nameEn?: string;
  tagline: string;
  taglineEn?: string;
  description: string;
  descriptionEn?: string;
  stack: string[];
  year: number;
  images: string[];
  accent: string; // PLANNINGJOY palette の violet/cyan/red 軸
}

export const products: Product[] = [
  {
    id: "host-checkin",
    name: "宿泊チェックインアプリ",
    nameEn: "Lodging Check-in App",
    tagline: "セルフチェックインの自動化基盤",
    taglineEn: "Automated self-check-in platform",
    description:
      "宿泊施設向けのセルフチェックイン用 Web アプリ。アクセスコード管理、ゲスト案内、運営側ダッシュボードを統合し、無人運営を支援。",
    descriptionEn:
      "A self-check-in web app for accommodation facilities. Integrates access code management, guest guidance, and an operations dashboard to enable unmanned operations.",
    stack: ["React", "Vite", "TypeScript", "Tailwind CSS"],
    year: 2025,
    images: [
      "/products/host/01_hero.jpg",
      "/products/host/02_scroll800.jpg",
      "/products/host/03_scroll1600.jpg",
      "/products/host/04_scroll2400.jpg",
    ],
    accent: "from-violet-500/40 via-purple-400/20 to-transparent",
  },
  {
    id: "pachinko-law",
    name: "風営法 学習アプリ",
    nameEn: "Entertainment Business Law Learning App",
    tagline: "風俗営業に携わる人のための風営法 Web 学習",
    taglineEn: "Web-based learning on entertainment business regulations",
    description:
      "パチンコ・麻雀・ゲームセンターなど幅広い業種の事業者・従業者向け。良質な学習教材が少なく行政書士頼みになりがちな風営法の知識を、問題集と解説でセルフ学習できます。",
    descriptionEn:
      "For business owners and employees in industries such as pachinko, mahjong parlors, and game centers. Enables self-study of entertainment business law knowledge — typically scarce in quality learning materials — through practice questions and explanations.",
    stack: ["React", "TypeScript", "Vite", "Tailwind CSS"],
    year: 2025,
    images: [
      "/products/pachinko/01_hero.jpg",
      "/products/pachinko/02_scroll800.jpg",
      "/products/pachinko/03_scroll1600.jpg",
      "/products/pachinko/04_scroll2400.jpg",
    ],
    accent: "from-amber-500/40 via-orange-400/20 to-transparent",
  },
  {
    id: "finance",
    name: "財務分析アプリ",
    nameEn: "Financial Analysis App",
    tagline: "AI による中小企業の経営指標可視化",
    taglineEn: "AI-powered management KPI visualization for SMEs",
    description:
      "決算書データを読み込み、AI が経営指標を分析・可視化する意思決定支援アプリ。中小企業の経営者はもちろん、税理士・中小企業診断士など財務の専門家にも活用できる設計で、認定支援機関としてのノウハウを組み込んだ実務水準の分析を提供。",
    descriptionEn:
      "A decision-support app that ingests financial statement data and uses AI to analyze and visualize management KPIs. Designed for both SME owners and financial professionals such as tax accountants and certified management consultants, delivering practice-level analysis incorporating know-how from a certified support agency.",
    stack: ["Next.js", "TypeScript", "Prisma", "Tailwind CSS"],
    year: 2026,
    images: [
      "/products/finance/01_hero.jpg",
      "/products/finance/02_scroll800.jpg",
      "/products/finance/03_scroll1600.jpg",
      "/products/finance/04_scroll2400.jpg",
    ],
    accent: "from-cyan-500/40 via-sky-400/20 to-transparent",
  },
  {
    id: "planningjoy",
    name: "PLANNINGJOY 公式サイト",
    nameEn: "PLANNINGJOY Official Website",
    tagline: "本サイト自体が AI 駆動開発の実践例",
    taglineEn: "This site itself is a live example of AI-driven development",
    description:
      "Claude Code と AI コーディングで設計・実装した自社のフルカスタム Web サイト。動的アニメーション、AI 用語集、AI ツールカタログ、AI 顧問サービスなど多面的なコンテンツを統合。",
    descriptionEn:
      "A fully custom company website designed and built with Claude Code and AI-assisted coding. Integrates rich content including dynamic animations, an AI glossary, an AI tools catalog, and an AI advisory service.",
    stack: ["React", "TypeScript", "Vite", "Tailwind CSS", "shadcn/ui", "Framer Motion"],
    year: 2025,
    images: [
      "/products/refined/01_hero.jpg",
      "/products/refined/02_scroll800.jpg",
      "/products/refined/03_scroll1600.jpg",
      "/products/refined/04_scroll2400.jpg",
      "/products/refined/05_ai-tools.jpg",
      "/products/refined/06_ai-glossary.jpg",
      "/products/refined/07_ai-support.jpg",
      "/products/refined/08_faq.jpg",
    ],
    accent: "from-rose-500/40 via-rose-400/20 to-transparent",
  },
];

// GitHub 非公開方針の説明文 (ページフッターに表示)
export const repoVisibilityNotice = `
当社のソースコードリポジトリは、ノウハウ・知財・アイデア流出防衛のため
原則非公開で運用しています。本ページに掲載のプロダクトは全て自社で実際に
開発・運用している実プロダクトであり、各 UI は本番環境のスクリーンショットです。
スタートアップ向けクレジット申請における GitHub 共有が必要な場合は、
個別に Read 限定の一時アクセストークンを発行する形で対応しています。
`.trim();
